// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"6f380dea27590ae2cea9","966":"ac7c0fad8132ee6e172c"}[chunkId] + ".js";
};